import { curry } from 'ramda';
import toAction from './toAction';

const dispatchFetchSuccess = curry(
  (dispatch, action, payload) =>
    dispatch(toAction(action, payload))
);

export default dispatchFetchSuccess;
